import { AnimationType, Direction, AnimationData } from './types';

export class AnimationLoader {
	static async loadAnimations(
		animationMap: AnimationData[]
	): Promise<Record<AnimationType, Record<Direction, p5.Image[]>>> {
		const animations: Record<AnimationType, Record<Direction, p5.Image[]>> = {
			idle: { east: [], west: [] },
			idle_blink: { east: [], west: [] },
			walk: { east: [], west: [] },
			run: { east: [], west: [] },
			jump: { east: [], west: [] },
			crouch: { east: [], west: [] },
			sneak: { east: [], west: [] },
			attack: { east: [], west: [] },
			hurt: { east: [], west: [] },
			wallclimb: { east: [], west: [] },
			wallgrab: { east: [], west: [] },
			fall: { east: [], west: [] },
			land: { east: [], west: [] },
			ledgestruggle: { east: [], west: [] },
			die: { east: [], west: [] },
			sit: { east: [], west: [] },
			sleep: { east: [], west: [] },
		};

		for (const { file, key, frames } of animationMap) {
			const spriteSheet = await loadImage(`./assets/models/cat/${file}`);
			const frameWidth = spriteSheet.width / frames;
			const frameHeight = spriteSheet.height;

			for (let i = 0; i < frames; i++) {
				// East (normal) frame
				const frameImg = createImage(frameWidth, frameHeight);
				frameImg.copy(
					spriteSheet,
					i * frameWidth,
					0,
					frameWidth,
					frameHeight,
					0,
					0,
					frameWidth,
					frameHeight
				);
				animations[key]['east'][i] = frameImg;

				// West (flipped) frame - pixel manipülasyonu ile önceden hazırla
				const westFrame = createImage(frameWidth, frameHeight);
				// Pixel okuma optimizasyonu için loadPixels'i çağır
				frameImg.loadPixels();
				westFrame.loadPixels();
				// Pixel'leri ters sırayla kopyala (yatay flip)
				const pixelCount = frameWidth * frameHeight;
				for (let j = 0; j < pixelCount; j++) {
					const y = Math.floor(j / frameWidth);
					const x = j % frameWidth;
					const srcX = frameWidth - 1 - x;
					const srcIndex = (y * frameWidth + srcX) * 4;
					const dstIndex = j * 4;
					westFrame.pixels[dstIndex] = frameImg.pixels[srcIndex]; // R
					westFrame.pixels[dstIndex + 1] = frameImg.pixels[srcIndex + 1]; // G
					westFrame.pixels[dstIndex + 2] = frameImg.pixels[srcIndex + 2]; // B
					westFrame.pixels[dstIndex + 3] = frameImg.pixels[srcIndex + 3]; // A
				}
				westFrame.updatePixels();
				animations[key]['west'][i] = westFrame;
			}
		}

		// Tüm sprite'ların yüklendiğini doğrula
		for (const key of Object.keys(animations) as AnimationType[]) {
			for (const dir of ['east', 'west'] as Direction[]) {
				const frames = animations[key][dir];
				for (let i = 0; i < frames.length; i++) {
					if (!frames[i] || frames[i].width === 0 || frames[i].height === 0) {
						console.warn(`Sprite not loaded: ${key}[${dir}][${i}]`);
					}
				}
			}
		}

		return animations;
	}
}
